import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { BaseService } from '@services/base-service.service';
import { API } from '@config/constants/api.constant';
import { BehaviorSubject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CustomsSnackbarComponent } from '@shared/components/customs-snackbar/customs-snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { STRING_CONSTANTS } from '@config/constants/string.constants';

@Component({
  selector: 'app-validate-scanner-ui-input',
  templateUrl: './validate-scanner-ui-input.component.html',
  styleUrls: ['./validate-scanner-ui-input.component.scss'],
})
export class ValidateScannerUiInputComponent implements OnInit {
  @Input() isValidateView: boolean = false;

  @Input() brandId: string;
  @ViewChildren('inputQrForm') inputQrForm: QueryList<ElementRef>;
  @ViewChildren('r2QrCode') r2QrCode: QueryList<ElementRef>;
  isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  audioError: any;
  audioSuccess: any;

  STRING_CONSTANTS = STRING_CONSTANTS;
  r1Code: string = '';
  r2Code: string = '';

  set input(element: ElementRef<HTMLInputElement>) {
    if (element) {
      element.nativeElement.focus();
    }
  }

  constructor(
    private baseService: BaseService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private activeRoute: ActivatedRoute,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.checkId();
    this.getSound();
  }

  checkId() {
    this.activeRoute.paramMap.subscribe((data) => {
      if (data) {
        this.brandId = data.get('id') ?? '';
      }
    });
  }

  scannerInput = this.formBuilder.group({
    qrManual: new FormControl('', [Validators.maxLength(9), Validators.minLength(9)]),
    qrCode: new FormControl('', [Validators.maxLength(9), Validators.minLength(9)]),
    qrCodeR2: new FormControl('', [Validators.maxLength(9), Validators.minLength(9)]),
  });

  onChangeR1Data($event: string) {
    if ($event.length === 9) {
      this.r2QrCode.first.nativeElement.focus();
      this.r1Code = $event;
    }
  }

  onChangeR2Data($event: string) {
    if ($event.length === 9) {
      this.postData(this.brandId, this.r1Code, $event);
      this.r2Code = $event;
    }
  }

  private get qrInputR1() {
    return this.scannerInput.get('qrCode');
  }

  get qrInputR2() {
    return this.scannerInput.get('qrCodeR2');
  }

  getSound() {
    this.audioError = new Audio('https://s3-ap-southeast-1.amazonaws.com/maxxi-staging/file/FILE_22b3a6a7-c203-4a20-92a2-ab1a24840665');
    this.audioSuccess = new Audio('https://s3-ap-southeast-1.amazonaws.com/maxxi-staging/file/FILE_eb5b5414-ca11-4e30-b39f-5cb4330020c6');
    this.audioSuccess.load();
  }

  soundError() {
    this.audioError.load();
    this.audioError.play();
    this.snackBar.openFromComponent(CustomsSnackbarComponent, {
      duration: 3000,
      horizontalPosition: 'end',
      data: {
        color: '#CC4435',
        text: 'Scan QR gagal',
        icon: STRING_CONSTANTS.ICON.IC_FAIL_SCAN_PRODUCT,
      },
    });
  }

  SuccessSound() {
    this.audioSuccess.load();
    this.audioSuccess.play();
    this.snackBar.openFromComponent(CustomsSnackbarComponent, {
      duration: 3000,
      horizontalPosition: 'end',
      data: {
        color: '#353535',
        text: 'Scan QR berhasil disimpan',
        icon: STRING_CONSTANTS.ICON.IC_BULLET_TICK_WHITE,
      },
    });
  }

  postData(brandId: string, qrR1Code: string, qrR2Code: string) {
    this.isLoading.next(true);
    this.baseService.getData<any>(API.VALIDATE_QR + brandId + '/' + qrR1Code + '/' + qrR2Code, { disableModalPopupError: true }).subscribe((res) => {
      if (res) {
        this.isLoading.next(false);
        this.r1Code = '';
        this.r2Code = '';
        this.qrInputR1?.setValue('');
        this.qrInputR2?.setValue('');
        if (res.success) {
          this.SuccessSound();
        } else {
          this.soundError();
        }
        this.ref.detectChanges();

        this.inputQrForm.first.nativeElement.focus();
      }
    });
  }

  clear() {
    this.r1Code = '';
    this.qrInputR1?.setValue('');
    this.r2Code = '';
    this.qrInputR2?.setValue('');
  }
}
